import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import './AiPage.css';
import { domain } from "../../services/constants";
import axios from "axios";
import background from '../../assets/Images/Aigradient.svg';

import useWindowDimensions from "../../hooks/useWindowDimensions";
import { openModal, showSignUpForm, showSignInForm } from "../../redux/slices/formDetails";
import { Link, useNavigate } from "react-router-dom";
import { toggleCreateFromScratchModalDuonut } from "../../redux/slices/CreateFromScratchReducer";
import { addUserActivity, selectUserActivity, removeUserActivity, updateUserActivityElements, setUserActivity } from '../../redux/slices/userActivity';
import { creditDeduction, getDuonut } from "../../services/duonut";
import { createDuonut } from "../../services/activity";
// import { toggleProMessageModalDuonut, updateProMessageModalMessage } from "../../redux/slices/ProMessageReducer";
import { addElementInUserActivity } from '../../redux/slices/userActivity';
import mammoth from 'mammoth';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import { AnimatePresence, motion } from 'framer-motion';
pdfjsLib.GlobalWorkerOptions.workerSrc = '/assets/file/pdf.worker.min.mjs';

var gptData = [];
var gptImageData = [];
var duonutId;
var isUpdateSlides = false;
const AiPage = () => {
    const { userActivities, } = useSelector((state) => state.userActivity);
    const { settings } = useSelector(state => state.duonutSettings);
    const { isLoggedIn, userProAccess, credit } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { width } = useWindowDimensions();

    const msgref = useRef(null);
    const msgref1 = useRef(null);
    const [selectedBtn, setselectedBtn] = useState(0);
    const [gptQuestionInput, setgptQuestionInput] = useState("Create 5 survey questions for delivery experience");
    const [gptType, setgptType] = useState(1);
    const [selectedCategory, setselectedCategory] = useState(1);
    const [selectedSlideNo, setselectedSlideNo] = useState(1);
    const [selectedTab, setselectedTab] = useState(1);
    const [errMsg, seterrMsg] = useState("");
    const [uploadedFile, setUploadedFile] = useState(null);
    const creditref = useRef(null);
    const creditref1 = useRef(null);
    const [message, setMessage] = useState("");
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [error_message, setErrorMessage] = useState("");
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const handleClick = () => dispatch(openModal());


    useEffect(() => {
        // console.log("after login")
        if (selectedBtn === 1) {
            navigate('/payment/pro');
            // window.open("https://rzp.io/l/9uSUqpj");
        } else if (selectedBtn === 2) {
            navigate('/payment/plus');
            // window.open("https://rzp.io/l/qYlzpZGWFE");
        } else if (selectedBtn === 3) {
            window.open("https://rzp.io/l/OjUDGY06");
        }
        // else if (selectedBtn === 4) {
        //     window.open("tel:" + "9353709306");
        // }
    }, [isLoggedIn]);

    const handleClickCreateFromScratch = () => {
        dispatch(toggleCreateFromScratchModalDuonut(true));
    };


    const handleGPTQuestionChange = (event) => {
        setgptQuestionInput(event.target.value);
        // console.log(event);
        // console.log(event.target.value);
        if (event.keyCode === 13) {
            document.getElementById("gptBtn").click();
        }
    };

    const handleUploadFile = (event) => {
        const file = event.target.files[0];
        // console.log(event);
        // console.log(event.target.value);

        if (file) {
            const fileSize = file.size; // size in bytes
            const fileSizeInKB = fileSize / 1024; // size in KB

            if (fileSizeInKB > 2048) {
                seterrMsg("Please upload less than 2 MB.");
                setTimeout(() => {
                    seterrMsg("");
                }, 3000); //miliseconds
                return null;
            }
        }

        setUploadedFile(file);
    };

    const continueBtn = () => {
        msgref1.current.click();
    }

    const handleCategoryChange = event => {
        // console.log(event);
        setselectedCategory(parseInt(event.target.value));

    };
    const handleSlideNoChange = event => {
        // console.log(event);
        setselectedSlideNo(event.target.value);

    };

    async function extractTextFromPDF(file) {
        const arrayBuffer = await file.arrayBuffer();
        const pdf = await pdfjsLib.getDocument(arrayBuffer).promise;
        const numPages = pdf.numPages;
        const textPromises = [];

        for (let pageNum = 1; pageNum <= numPages; pageNum++) {
            textPromises.push(pdf.getPage(pageNum).then(page => page.getTextContent()));
        }

        const texts = await Promise.all(textPromises);
        return texts.map(textContent => textContent.items.map(item => item.str).join(' ')).join('\n');
    }

    async function extractTextFromDOCX(file) {
        const arrayBuffer = await file.arrayBuffer();
        const result = await mammoth.extractRawText({ arrayBuffer });
        return result.value;
    }

    const handleGPTSubmit = async () => {

        if (!isLoggedIn) {
            handleClick();
            dispatch(showSignInForm());
            return;
        }

        if (!gptQuestionInput && gptType === 1) {
            msgref.current.click();
            return;
        }

        if (!uploadedFile && gptType === 2) {
            seterrMsg("Please upload audio file.");
            setTimeout(() => {
                seterrMsg("");
            }, 3000); //miliseconds
            return;
        }

        if (!uploadedFile && gptType === 3) {
            seterrMsg("Please upload pdf / doc file.");
            setTimeout(() => {
                seterrMsg("");
            }, 3000); //miliseconds
            return;
        }

        const aiPageFirstTime = localStorage.getItem("aft");

        // if (!userProAccess && aiPageFirstTime) {
        //     dispatch(toggleProMessageModalDuonut(true));
        //     dispatch(updateProMessageModalMessage('Duonut Ai access'));
        //     return null;
        // }

        if (credit >= 30) {
            var creditData = {
                name: "AI Survey Maker",
                message: "AI Survey Maker",
                cost: 30,
            }
            creditDeduction(creditData, (err, res) => {
                if (err) return console.log(err.response);
                // console.log(res);
            });

            setMessage('Credit has been deducted');
            setShowSuccessMessage(true);
            setTimeout(() => setShowSuccessMessage(false), 5000);
            creditref1.current.click();
        }
        else {
            setErrorMessage('There is no sufficient credit to perform this operation');
            setShowErrorMessage(true);
            setTimeout(() => setShowErrorMessage(false), 5000);
            return;
            // console.log("Insufficient credits");
        }
        localStorage.setItem("aft", true);

        setselectedTab(2);
        gptData = [];
        var newQuestion;

        if (gptType === 1) {
            if (selectedCategory === 1) {
                newQuestion = gptQuestionInput + ` ${selectedSlideNo} Survey questions with options`;
            } else if (selectedCategory === 2) {
                newQuestion = gptQuestionInput + ` ${selectedSlideNo} MCQ questions with answer options`;
            } else if (selectedCategory === 3) {
                newQuestion = `write ${selectedSlideNo} small paragraph on ` + gptQuestionInput;
            } else if (selectedCategory === 4) {
                const stopWords = ["create"];
                // Split the sentence into an array of words
                const words = gptQuestionInput.split(" ");
                // Filter out the stop words
                const filteredWords = words.filter(word => !stopWords.includes(word.toLowerCase()));
                // Join the remaining words back into a sentence
                const finalSentence = filteredWords.join(" ");
                newQuestion = `create a form with FieldName and type in json ` + finalSentence;
            }

            GPTApi(newQuestion);
        } else if (gptType === 2) {

            var payloadWhisper = {
                file: uploadedFile,
                model: "whisper-1",
            }
            axios({
                method: "POST",
                url: "https://api.openai.com/v1/audio/transcriptions",
                data: payloadWhisper,
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization:
                        "Bearer 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"
                }
            }).then((res) => {
                // console.log(res.data.text);

                if (selectedCategory === 1) {
                    newQuestion = res?.data?.text + ` create ${selectedSlideNo} Survey questions with options from this summary`;
                } else if (selectedCategory === 2) {
                    newQuestion = res?.data?.text + ` create ${selectedSlideNo} MCQ questions with answer options from this summary`;
                } else if (selectedCategory === 3) {
                    newQuestion = res?.data?.text + ` write ${selectedSlideNo} small paragraph from this summary`;
                } else if (selectedCategory === 4) {
                    newQuestion = `create a form with FieldName and type in json from this summary` + res?.data?.text;
                }

                GPTApi(newQuestion);

            }).catch((e) => {
                console.log(e.message, e);
            });

        } else if (gptType === 3) {

            if (uploadedFile.type === "application/pdf") {
                const extractedText = await extractTextFromPDF(uploadedFile);
                // console.log(extractedText);

                if (selectedCategory === 1) {
                    newQuestion = extractedText + ` create ${selectedSlideNo} Survey questions with options from this summary`;
                } else if (selectedCategory === 2) {
                    newQuestion = extractedText + ` create ${selectedSlideNo} MCQ questions with answer options from this summary`;
                } else if (selectedCategory === 3) {
                    newQuestion = extractedText + ` write ${selectedSlideNo} small paragraph from this summary`;
                } else if (selectedCategory === 4) {
                    newQuestion = `create a form with FieldName and type in json from this summary` + extractedText;
                }

                GPTApi(newQuestion);
            } else if (uploadedFile.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
                const extractedText = await extractTextFromDOCX(uploadedFile);
                // console.log(extractedText);

                if (selectedCategory === 1) {
                    newQuestion = extractedText + ` create ${selectedSlideNo} Survey questions with options from this summary`;
                } else if (selectedCategory === 2) {
                    newQuestion = extractedText + ` create ${selectedSlideNo} MCQ questions with answer options from this summary`;
                } else if (selectedCategory === 3) {
                    newQuestion = extractedText + ` write ${selectedSlideNo} small paragraph from this summary`;
                } else if (selectedCategory === 4) {
                    newQuestion = `create a form with FieldName and type in json from this summary` + extractedText;
                }

                GPTApi(newQuestion);
            }
        }

    }

    const GPTApi = (newQuestion) => {

        var payload = {};
        if (selectedCategory === 4) {
            payload = {
                messages: [{ "role": "user", "content": newQuestion }],
                max_tokens: 2000,
                temperature: 0.7,
                n: 1,
                model: "gpt-3.5-turbo",
                response_format: { "type": "json_object" }
            }
        } else {
            payload = {
                messages: [{ "role": "user", "content": newQuestion }],
                max_tokens: 2000,
                temperature: 0.7,
                n: 1,
                model: "gpt-3.5-turbo",
            }
        }

        axios({
            method: "POST",
            url: "https://api.openai.com/v1/chat/completions",
            data: payload,
            headers: {
                "Content-Type": "application/json",
                Authorization:
                    "Bearer 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"
            }
        }).then((res) => {
            // console.log(res);
            if (res?.status === 200) {
                // console.log(res.data);
                if (parseInt(selectedSlideNo) > 1 && selectedCategory !== 4) {
                    // List of stop words to be removed
                    const stopWords = ["is", "a", "that", "in", "the", "on", "and", "an", "to", "for", "of", "with", "by", "as",
                        "question", "questions", "create", "about", "mcq", "mcqs", "option", "options", "answer", "answers",
                        "survey", "story", "form", "write", "paragraph", "summary"
                    ];
                    // Split the sentence into an array of words
                    const words = gptQuestionInput ? gptQuestionInput.split(" ") : newQuestion.split(" ");

                    // Filter out the stop words
                    const filteredWords = words.filter(word => !stopWords.includes(word.toLowerCase()));

                    // Join the remaining words back into a sentence
                    const finalSentence = filteredWords.join(" ");

                    // console.log(words.length);
                    if (words.length > 25) {
                        var summ = gptQuestionInput ? gptQuestionInput : newQuestion;
                        var newQues = `give 1 line proper title for this summary ` + summ;
                        // console.log(newQues);
                        var newpayload = {
                            messages: [{ "role": "user", "content": newQues }],
                            max_tokens: 2000,
                            temperature: 0.7,
                            n: 1,
                            model: "gpt-3.5-turbo",
                        }

                        axios({
                            method: "POST",
                            url: "https://api.openai.com/v1/chat/completions",
                            data: newpayload,
                            headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                    "Bearer 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"
                            }
                        }).then((res) => {
                            // console.log(res);
                            if (res?.status === 200) {
                                const payload1 = {
                                    model: "dall-e-2",
                                    prompt: res?.data?.choices[0]?.message?.content,
                                    n: parseInt(selectedSlideNo) >= 4 ? 3 : parseInt(selectedSlideNo) >= 3 ? 2 : 1,
                                    size: "256x256",
                                    response_format: "b64_json",
                                }
                                axios({
                                    method: "POST",
                                    url: "https://api.openai.com/v1/images/generations",
                                    data: payload1,
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization:
                                            "Bearer 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"
                                    }
                                }).then((res1) => {
                                    // console.log(res1);
                                    var imageData = [];
                                    if (res1?.data?.data?.length > 0) {
                                        res1?.data?.data?.map((item, i) => {
                                            imageData.push(item.b64_json);
                                        })
                                        // console.log(imageData);
                                        gptImageData = imageData;
                                        convertInJson(res.data.choices[0]?.message.content);
                                    }
                                }).catch((e) => {
                                    console.log(e.message, e);
                                });
                            }
                        }).catch((e) => {
                            console.log(e.message, e);
                        });

                    } else {

                        const payload1 = {
                            model: "dall-e-2",
                            prompt: finalSentence,
                            n: parseInt(selectedSlideNo) >= 4 ? 3 : parseInt(selectedSlideNo) >= 3 ? 2 : 1,
                            size: "256x256",
                            response_format: "b64_json",
                        }
                        axios({
                            method: "POST",
                            url: "https://api.openai.com/v1/images/generations",
                            data: payload1,
                            headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                    "Bearer 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"
                            }
                        }).then((res1) => {
                            // console.log(res1);
                            var imageData = [];
                            if (res1?.data?.data?.length > 0) {
                                res1?.data?.data?.map((item, i) => {
                                    imageData.push(item.b64_json);
                                })
                                // console.log(imageData);
                                gptImageData = imageData;
                                convertInJson(res.data.choices[0]?.message.content);
                            }
                        }).catch((e) => {
                            console.log(e.message, e);
                        });

                    }

                } else {
                    convertInJson(res.data.choices[0]?.message.content);
                }
            }
        }).catch((e) => {
            console.log(e.message, e);
        });

    }

    function extractFields(jsonData) {
        // Check if 'fields' key exists directly within jsonData
        if (jsonData?.fields) {
            return jsonData.fields;
        }
        // Check if 'form' key exists and then 'fields' within 'form'
        if (jsonData?.form && jsonData?.form?.fields) {
            return jsonData.form.fields;
        }

        if (jsonData.Fields) {
            return jsonData.Fields;
        }
        if (jsonData.Form && jsonData.Form.Fields) {
            return jsonData.Form.Fields;
        }
        // Return an empty array or null if 'fields' not found in any format
        return [];
    }

    const convertInJson = (res) => {
        // console.log(res, gptQuestionInput, selectedCategory);
        let jsonData = [];

        if (selectedCategory === 1) {
            // console.log("survey");
            let splitData = res.split(/\n\n\d+\.\s|\n\d+\.\s/).filter(element => element);
            // console.log(splitData);
            splitData.map((item, i) => {
                let splitData1 = item.split("\n").filter(element => element);
                jsonData.push(splitData1);
            })

        } else if (selectedCategory === 2) {
            // console.log("mcq");
            let splitData = res.split(/\n\nQ\d+\.\s|\n\n\d+\.\s/).filter(element => element);
            // console.log(splitData);
            splitData.map((item, i) => {
                let splitData1 = item.split("\n").filter(element => element);
                jsonData.push(splitData1);
            })

        } else if (selectedCategory === 3) {
            // console.log("story");
            let splitData = res.split("\n\n").filter(element => element);
            // console.log(splitData);
            splitData.map((item, i) => {
                jsonData.push(item);
            })

        } else if (selectedCategory === 4) {
            // console.log("Form", JSON.parse(res));
            var formData = extractFields(JSON.parse(res))
            jsonData.push(formData);

        }

        // console.log(jsonData);
        gptData = jsonData;
        handleCreateDuonut();
    };


    let interval = null;
    const handleCreateDuonut = () => {
        const controller = new AbortController();
        interval = setInterval(() => {
            if (isLoggedIn) {
                clearInterval(interval);
                createDuonut({ name: "Untitled", duonut_category: 1, duonut_setting: settings }, controller, (err, res) => {
                    // setLoading(false);
                    clearInterval(interval);
                    if (err) {
                        console.log(err);
                        return;
                    }
                    // console.log('DUONUT CREATED --- ');
                    duonutId = res?.data?.id;
                    handleSelectTheme();

                });
            }
        }, 10);

        return () => {
            controller.abort();
            clearInterval(interval)
        };
    }

    const handleSelectTheme = () => {
        // console.log(masterData, gptData);

        dispatch(setUserActivity({
            activities: [{
                elements: [],
                backgroundColor: "white",
                backgroundImage: "",
            }]
        }));

        // var duonutId = 107;
        var duonutId = 205;

        if (selectedCategory === 1) {
            // duonutId = 107;
            duonutId = 205;
        } else if (selectedCategory === 2) {
            // duonutId = 108;
            duonutId = 206;
        }
        else if (selectedCategory === 3) {
            // duonutId = 109;
            duonutId = 207;
        }

        if (selectedCategory !== 4) {
            getDuonut(duonutId, (err, res) => {
                // console.log("fetch duonut resp", res);
                if (err) {
                    console.log(err);
                    return;
                }
                // console.log("fetch duonut res.data", res.data)
                gptData.map((item, i) => {
                    // console.log(i);
                    if (selectedSlideNo < i + 1) return;

                    var masterData = res.data.user_activity[i];
                    dispatch(addUserActivity({ ...masterData, name: `Step ${i + 1}` }));
                })
                dispatch(removeUserActivity({ idx: 0 }));
                dispatch(selectUserActivity(0));
                isUpdateSlides = true;

            });
        } else {
            [1, 2, 3, 4, 5].map((item, i) => {
                // console.log(i);
                if (selectedSlideNo < i + 1) return;

                const stopWords = ["create"];
                // Split the sentence into an array of words
                const words = gptQuestionInput?.split(" ");
                // Filter out the stop words
                const filteredWords = words?.filter(word => !stopWords.includes(word.toLowerCase()));
                // Join the remaining words back into a sentence
                const finalSentence = filteredWords?.join(" ");

                var masterData = {
                    elements: [
                        {
                            id: 1,
                            elementType: 'Text',
                            transparency: 1,
                            zIndex: 1,
                            order: 1,
                            posX: 0,
                            posY: 30,
                            height: "auto",
                            width: "100%",
                            elementAttributes: {
                                color: '#000000', text: finalSentence ? finalSentence : "Set Title", formattedText: [], fontFamily: "Poppins",
                                fontWeight: 800, fontSize: 24, textAlign: "center"
                            },
                        },
                        {
                            id: 2,
                            elementType: 'Button',
                            transparency: 1,
                            zIndex: 2,
                            order: 2,
                            posX: 410,
                            posY: 500,
                            height: "auto",
                            width: 200,
                            elementAttributes: {
                                color: '#ffffff', text: "Next", fontFamily: "Poppins",
                                fontWeight: 600, fontSize: 16, backgroundColor: "#000000", border: "1px solid #000000",
                                textAlign: "center", borderRadius: "5px"
                            },
                            elementHoverAttributes: {
                                color: '#ffffff', backgroundColor: "blue", border: "1px solid #000000"
                            },
                        }
                    ],
                    backgroundColor: "#ffffff",
                    backgroundImage: "",
                    name: "Step 1",
                };
                dispatch(addUserActivity({ ...masterData, name: `Step ${i + 1}` }));
            })
            dispatch(removeUserActivity({ idx: 0 }));
            dispatch(selectUserActivity(0));
            isUpdateSlides = true;
        }
    };
    function selectFields(jsonElement, idNum) {
        var labelText = jsonElement?.fieldName ? jsonElement?.fieldName :
            jsonElement?.FieldName ? jsonElement?.FieldName :
                jsonElement?.label ? jsonElement?.label :
                    jsonElement?.question ? jsonElement?.question : "type your label";

        if (jsonElement?.type === "text") {
            var element = {
                id: idNum + 1,
                elementType: 'TextField',
                transparency: 1,
                zIndex: idNum + 1,
                order: idNum + 1,
                posX: 245,
                posY: 100 + (130 * (idNum - 2)),
                height: "auto",
                width: 500,
                elementAttributes: {
                    color: '#000000', text: labelText, fontFamily: "Poppins",
                    fontWeight: 400, fontSize: 16, backgroundColor: "#ffffff", border: "1px solid #000000",
                    textAlign: "left", borderRadius: "0px", fieldPosition: "column",
                    placeholder: "Type your text here."
                }
            }
            return element;
        }

        if (jsonElement?.type === "textarea") {
            var element = {
                id: idNum + 1,
                elementType: 'TextArea',
                transparency: 1,
                zIndex: idNum + 1,
                order: idNum + 1,
                posX: 245,
                posY: 100 + (130 * (idNum - 2)),
                height: "auto",
                width: 500,
                elementAttributes: {
                    color: '#000000', text: labelText, fontFamily: "Poppins",
                    fontWeight: 400, fontSize: 16, backgroundColor: "#ffffff", border: "1px solid #000000",
                    textAlign: "left", borderRadius: "0px", fieldPosition: "column",
                    placeholder: "Type your text here."
                }
            }
            return element;
        }

        if (jsonElement?.type === "email") {
            var element = {
                id: idNum + 1,
                elementType: 'Email',
                transparency: 1,
                zIndex: idNum + 1,
                order: idNum + 1,
                posX: 245,
                posY: 100 + (130 * (idNum - 2)),
                height: "auto",
                width: 500,
                elementAttributes: {
                    color: '#000000', text: labelText, fontFamily: "Poppins",
                    fontWeight: 400, fontSize: 16, backgroundColor: "#ffffff", border: "1px solid #000000",
                    textAlign: "left", borderRadius: "0px", fieldPosition: "column",
                    placeholder: "Type your Email here."
                }
            }
            return element;
        }

        if (jsonElement?.type === "password") {
            var element = {
                id: idNum + 1,
                elementType: 'Password',
                transparency: 1,
                zIndex: idNum + 1,
                order: idNum + 1,
                posX: 245,
                posY: 100 + (130 * (idNum - 2)),
                height: "auto",
                width: 500,
                elementAttributes: {
                    color: '#000000', text: labelText, fontFamily: "Poppins",
                    fontWeight: 400, fontSize: 16, backgroundColor: "#ffffff", border: "1px solid #000000",
                    textAlign: "left", borderRadius: "0px", fieldPosition: "column",
                    placeholder: "Type your Password here."
                }
            }
            return element;
        }

        if (jsonElement?.type === "tel") {
            var element = {
                id: idNum + 1,
                elementType: 'Phone',
                transparency: 1,
                zIndex: idNum + 1,
                order: idNum + 1,
                posX: 245,
                posY: 100 + (130 * (idNum - 2)),
                height: "auto",
                width: 500,
                elementAttributes: {
                    color: '#000000', text: labelText, fontFamily: "Poppins",
                    fontWeight: 400, fontSize: 16, backgroundColor: "#ffffff", border: "1px solid #000000",
                    textAlign: "left", borderRadius: "0px", fieldPosition: "column",
                    placeholder: "Type your Phone number here."
                }
            }
            return element;
        }

        if (jsonElement?.type === "number") {
            var element = {
                id: idNum + 1,
                elementType: 'NumberField',
                transparency: 1,
                zIndex: idNum + 1,
                order: idNum + 1,
                posX: 245,
                posY: 100 + (130 * (idNum - 2)),
                height: "auto",
                width: 500,
                elementAttributes: {
                    color: '#000000', text: labelText, fontFamily: "Poppins",
                    fontWeight: 400, fontSize: 16, backgroundColor: "#ffffff", border: "1px solid #000000",
                    textAlign: "left", borderRadius: "0px", fieldPosition: "column",
                    placeholder: "Type your number here."
                }
            }
            return element;
        }

        if (jsonElement?.type === "date") {
            var element = {
                id: idNum + 1,
                elementType: 'DateField',
                transparency: 1,
                zIndex: idNum + 1,
                order: idNum + 1,
                posX: 245,
                posY: 100 + (130 * (idNum - 2)),
                height: "auto",
                width: 500,
                elementAttributes: {
                    color: '#000000', text: labelText, fontFamily: "Poppins",
                    fontWeight: 400, fontSize: 16, backgroundColor: "#ffffff", border: "1px solid #000000",
                    textAlign: "left", borderRadius: "0px", fieldPosition: "column",
                }
            }
            return element;
        }

        if (jsonElement?.type === "file") {
            var element = {
                id: idNum + 1,
                elementType: 'FileUpload',
                transparency: 1,
                zIndex: idNum + 1,
                order: idNum + 1,
                posX: 245,
                posY: 100 + (130 * (idNum - 2)),
                height: "auto",
                width: 500,
                elementAttributes: {
                    color: '#000000', text: labelText, fontFamily: "Poppins",
                    fontWeight: 400, fontSize: 16, backgroundColor: "#ffffff", border: "1px solid #000000",
                    textAlign: "left", borderRadius: "0px", fieldPosition: "column",
                }
            }
            return element;
        }

        // Return an empty array or null if 'fields' not found in any format
        return {};
    }

    useEffect(() => {
        console.log(userActivities, gptData, gptImageData, duonutId, isUpdateSlides);

        if (selectedCategory === 1 && userActivities.length > 0 && isUpdateSlides && duonutId) {
            // console.log("survey inside");
            isUpdateSlides = false;
            var imageCount = 0;

            userActivities.map((activity, i) => {
                if (activity.elements.some(element => element.elementType === "CheckboxGroup")) {
                    let tempElement = activity?.elements?.find(element => element?.elementType === "CheckboxGroup");
                    const elementAttrib = tempElement?.elementAttributes;
                    // console.log("tempElement1", tempElement)

                    tempElement = {
                        ...tempElement,
                        elementAttributes: {
                            ...elementAttrib,
                            text: gptData[i][0],
                            options: gptData[i].slice(1)
                        },
                    };
                    // console.log("tempElement2", tempElement)
                    dispatch(
                        updateUserActivityElements({
                            selectedActivityIdx: i,
                            selectedElementIdx: activity?.elements?.findIndex(element => element?.elementType === "CheckboxGroup"),
                            element: tempElement,
                        })
                    );

                }
                if (activity.elements.some(element => element.elementType === "Image")) {
                    let tempElement = activity?.elements?.find(element => element?.elementType === "Image");
                    const elementAttrib = tempElement?.elementAttributes;

                    const dataUrlPrefix = `data:image/png;base64,`;
                    const image_data = {
                        duonut_id: duonutId,
                        name: `${duonutId}-${i}`,
                        uri: dataUrlPrefix + gptImageData[imageCount],
                    }
                    axios({
                        method: "POST",
                        url: `${domain}/duonut/upload_files`,
                        headers: {
                            "Content-Type": "application/json"
                        },
                        data: JSON.stringify(image_data),
                    }).then((res) => {
                        // console.log(res.data.file_url);
                        tempElement = {
                            ...tempElement,
                            elementAttributes: {
                                ...elementAttrib,
                                url_data: {},
                                // url: res.data.file_url,
                                url: "https://duonutfiles.s3.amazonaws.com/duonut/1183/aJTiW00qqtI",
                            },
                        };
                        dispatch(
                            updateUserActivityElements({
                                selectedActivityIdx: i,
                                selectedElementIdx: activity?.elements?.findIndex(element => element?.elementType === "Image"),
                                element: tempElement,
                            })
                        );

                        imageCount++;

                    }).catch((e) => {
                        console.log(e.message, e);
                    });

                }
            })

            setTimeout(() => {
                navigate(`/design/${duonutId}`);
            }, 1000);

        }

        if (selectedCategory === 2 && userActivities.length > 0 && isUpdateSlides && duonutId) {
            // console.log("mcq inside");
            isUpdateSlides = false;

            var imageCount = 0;
            userActivities.map((activity, i) => {
                if (activity.elements.some(element => element.elementType === "Mcq")) {

                    let tempElement = activity?.elements?.find(element => element?.elementType === "Mcq");
                    const elementAttrib = tempElement?.elementAttributes;
                    // console.log("tempElement1", tempElement)
                    // var options = gptData[i].slice(1, 5);
                    // var ansoption = gptData[i][5];
                    // var ansoption1 = ansoption?.split("Answer:")[1]?.trim();

                    // Get the options and answer
                    let options = [];
                    for (let j = 1; j < gptData[i].length; j++) {
                        if (gptData[i][j].startsWith("Answer:")) {
                            break;
                        }
                        options.push(gptData[i][j]);
                    }

                    // Get the correct answer from the options
                    const ansoption = gptData[i].find(option => option.startsWith("Answer:"));
                    const ansoption1 = ansoption?.split("Answer:")[1]?.trim();

                    // Find the correct answer index (1-based)
                    const correctAnswerIndex = options.indexOf(ansoption1) !== -1 ? options.indexOf(ansoption1) + 1 : 1;

                    tempElement = {
                        ...tempElement,
                        elementAttributes: {
                            ...elementAttrib,
                            text: gptData[i][0],
                            options: options,
                            correctAnswer: correctAnswerIndex,
                        },
                    };
                    // console.log("tempElement2", tempElement)
                    dispatch(
                        updateUserActivityElements({
                            selectedActivityIdx: i,
                            selectedElementIdx: activity?.elements?.findIndex(element => element?.elementType === "Mcq"),
                            element: tempElement,
                        })
                    );

                }
                if (activity.elements.some(element => element.elementType === "Image")) {
                    let tempElement = activity?.elements?.find(element => element?.elementType === "Image");
                    const elementAttrib = tempElement?.elementAttributes;

                    const dataUrlPrefix = `data:image/png;base64,`;
                    const image_data = {
                        duonut_id: duonutId,
                        name: `${duonutId}-${i}`,
                        uri: dataUrlPrefix + gptImageData[imageCount],
                    }
                    axios({
                        method: "POST",
                        url: `${domain}/duonut/upload_files`,
                        headers: {
                            "Content-Type": "application/json"
                        },
                        data: JSON.stringify(image_data),
                    }).then((res) => {
                        //console.log(res.data.file_url);
                        tempElement = {
                            ...tempElement,
                            elementAttributes: {
                                ...elementAttrib,
                                url_data: {},
                                // url: res.data.file_url,
                                url: "https://duonutfiles.s3.amazonaws.com/duonut/1183/aJTiW00qqtI",
                            },
                        };
                        dispatch(
                            updateUserActivityElements({
                                selectedActivityIdx: i,
                                selectedElementIdx: activity?.elements?.findIndex(element => element?.elementType === "Image"),
                                element: tempElement,
                            })
                        );

                        imageCount++;
                    }).catch((e) => {
                        console.log(e.message, e);
                    });

                }
            })

            setTimeout(() => {
                navigate(`/design/${duonutId}`);
            }, 1000);

        }

        if (selectedCategory === 3 && userActivities.length > 0 && isUpdateSlides && duonutId) {
            // console.log("story inside");
            isUpdateSlides = false;

            var imageCount = 0;
            userActivities.map((activity, i) => {
                var countNub = 0;
                activity?.elements?.forEach((element, elementIndex) => {
                    if (element.elementType === "Text") {
                        let tempElement = element;
                        const elementAttrib = tempElement?.elementAttributes;

                        tempElement = {
                            ...tempElement,
                            elementAttributes: {
                                ...elementAttrib,
                                text: countNub === 0 ? gptQuestionInput ? gptQuestionInput : "Set Title" : gptData[i],
                            },
                        };

                        countNub++;

                        dispatch(
                            updateUserActivityElements({
                                selectedActivityIdx: i,
                                selectedElementIdx: elementIndex,
                                element: tempElement,
                            })
                        );
                    }
                    if (element.elementType === "Image") {
                        let tempElement = element;
                        const elementAttrib = tempElement?.elementAttributes;

                        const dataUrlPrefix = `data:image/png;base64,`;
                        const image_data = {
                            duonut_id: duonutId,
                            name: `${duonutId}-${i}`,
                            uri: dataUrlPrefix + gptImageData[imageCount],
                        }
                        axios({
                            method: "POST",
                            url: `${domain}/duonut/upload_files`,
                            headers: {
                                "Content-Type": "application/json"
                            },
                            data: JSON.stringify(image_data),
                        }).then((res) => {
                            //console.log(res.data.file_url);
                            tempElement = {
                                ...tempElement,
                                elementAttributes: {
                                    ...elementAttrib,
                                    url_data: {},
                                    // url: res.data.file_url,
                                    url: "https://duonutfiles.s3.amazonaws.com/duonut/1183/aJTiW00qqtI",
                                },
                            };
                            dispatch(
                                updateUserActivityElements({
                                    selectedActivityIdx: i,
                                    selectedElementIdx: elementIndex,
                                    element: tempElement,
                                })
                            );
                            imageCount++;

                        }).catch((e) => {
                            console.log(e.message, e);
                        });

                    }
                });

            })

            setTimeout(() => {
                navigate(`/design/${duonutId}`);
            }, 1000);

        }

        if (selectedCategory === 4 && userActivities.length > 0 && isUpdateSlides && duonutId) {
            // console.log("form inside");
            isUpdateSlides = false;

            var elementsPerActivity = 3;
            var currentIndex = 0;

            userActivities.map((activity, i) => {
                var idNum = 2;
                var elementsAdded = 0;

                while (elementsAdded < elementsPerActivity && currentIndex < gptData[0].length) {
                    const jsonElement = gptData[0][currentIndex];
                    // console.log("jsonElement", jsonElement);
                    const element = selectFields(jsonElement, idNum);

                    // console.log("element", element);
                    // Check if element is not an empty object
                    if (Object.keys(element).length !== 0) {
                        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: i }));
                        elementsAdded++;
                        idNum++;
                    }

                    currentIndex++;
                }
            })

            // filter not working
            // const filteredActivities = userActivities.filter((activity) => activity.elements.length !== 2);
            // dispatch(setUserActivity(filteredActivities));

            // console.log("userActivities", userActivities)

            setTimeout(() => {
                // console.log("userActivities1", userActivities)
                navigate(`/design/${duonutId}`);
            }, 1000);
        }


    }, [userActivities, isUpdateSlides]);


    return (
        <>
            <button ref={creditref} style={{ display: "none" }} type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#creditModal">
            </button>
            <div className="modal fade" style={{ backgroundColor: "#1e1d1d6b", zIndex: "99999" }} id="creditModal" tabIndex="-1" aria-labelledby="creditModalLabel" aria-hidden="true">
                <div className="modal-dialog" style={{ maxWidth: "40vw" }}>
                    <div className="modal-content" style={{ marginTop: "30vh", textAlign: "center", backgroundColor: "white", color: "black", border: "2px solid gray", borderRadius: "15px" }}>
                        <div className="modal-body">
                            <button ref={creditref1} style={{ display: "none" }} type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <h2 style={{ margin: "2vh 0vh" }}> Credit Deduct</h2>
                            <br></br>
                            <div style={{}}>
                                <label style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <img src="../../assets/icons/coin-3.svg" style={{ width: "2rem", height: "2rem" }} alt="coin icon" />&nbsp;
                                    20 coins will be used to perform this operation.
                                </label></div>
                            <br></br>

                            <button className='QRC1Continuebtn' onClick={() => handleGPTSubmit()}>Ok</button>
                            <button className="QRC1Continuebtn" style={{ margin: "2vh", border: "1px solid black" }}
                                onClick={() => creditref1.current.click()}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='AI1App'
                style={{ backgroundImage: `url(${background})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
            >
                <button ref={msgref} style={{ display: "none" }} type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#msgModal">
                </button>
                <div className="modal fade" style={{ backgroundColor: "#1e1d1d6b" }} id="msgModal" tabIndex="-1" aria-labelledby="msgModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content LB1modalMain" style={{ backgroundColor: "white", color: "black", border: "2px solid gray", borderRadius: "15px" }}>
                            <div className="modal-body">
                                <button ref={msgref1} style={{ display: "none" }} type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <div style={{ margin: "2vh 0vh", fontSize: "1.4rem", fontWeight: "400" }}> Type a question to generate content for you.</div>
                                <br></br>
                                <button className="btn-primary" style={{ margin: "2vh", border: "1px solid black" }}
                                    onClick={() => continueBtn()}>Continue</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='AI1template'>
                    {selectedTab === 1 && <>
                        <div className="AI1headingContainer">
                            <h1 className="AI1heading">Supercharge your forms and workflows with AI.</h1>
                            <div style={{ fontSize: "1.2rem" }}>Duonut AI lets you create high quality forms and workflows in seconds.<br></br> You can always polish the final experience in our powerful Editor.
                            </div>
                        </div>

                        <div style={{ backgroundColor: "rgba(8,17,47,.07)", padding: "10px", borderRadius: "16px", boxShadow: "0 22px 44px -12px rgba(25,47,89,.38)" }}>
                            <div className="AI1container">
                                <h3 style={{ paddingBottom: "1rem" }}> AI workflow generator </h3>
                                <div className="AI1btnContainer" style={{ marginBottom: "1rem", paddingTop: "0" }}>
                                    <label>
                                        <input type="radio" id="Text" name="gptType" onChange={() => setgptType(1)} checked={gptType === 1} />
                                        <label for="Text" style={{ paddingLeft: "8px" }}>Text</label>
                                    </label>
                                    <label>
                                        <input type="radio" id="Audio/Video" name="gptType" onChange={() => setgptType(2)} checked={gptType === 2} />
                                        <label for="Audio/Video" style={{ paddingLeft: "8px" }}>Audio</label>
                                    </label>
                                    <label>
                                        <input type="radio" id="Document" name="gptType" onChange={() => setgptType(3)} checked={gptType === 3} />
                                        <label for="Document" style={{ paddingLeft: "8px" }}>Document</label>
                                    </label>
                                </div>
                                {gptType === 1 && <input className='GPT-input_box'
                                    id="GPT-input_box"
                                    type="text"
                                    // placeholder="Type your question"
                                    value={gptQuestionInput}
                                    // onKeyUp={e => handleGPTQuestionChange(e)}
                                    onChange={e => setgptQuestionInput(e.target.value)}
                                />}
                                {gptType === 2 && <input className='GPT-input_box'
                                    id="GPT-input_box"
                                    type="file"
                                    accept={"audio/*"}
                                    onChange={e => handleUploadFile(e)}
                                />}
                                {gptType === 3 && <input className='GPT-input_box'
                                    id="GPT-input_box"
                                    type="file"
                                    accept=".pdf, .doc, .docx"
                                    onChange={e => handleUploadFile(e)}
                                />}
                                {errMsg && <div style={{ color: 'red', padding: '10px' }}>{errMsg}</div>}
                                <div className="AI1btnContainer">
                                    <div>Category
                                        <select id="mySelect" style={{ padding: "5px", marginLeft: "0.6rem", width: "8rem" }} value={selectedCategory}
                                            onChange={e => handleCategoryChange(e)}>
                                            <option selected value="1">Survey</option>
                                            <option value="2">MCQ</option>
                                            <option value="3">Story</option>
                                            <option value="4">Form</option>
                                        </select>
                                    </div>
                                    <div style={{ paddingLeft: "1rem" }}>Slide
                                        <select id="mySelect1" style={{ padding: "5px", marginLeft: "0.6rem", width: "8rem" }} value={selectedSlideNo}
                                            onChange={e => handleSlideNoChange(e)}>
                                            <option selected value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                        </select>
                                    </div>
                                    <button type='submit' id="gptBtn" className='GPT-submitBtn' onClick={() => creditref.current.click()}>Generate</button>
                                </div>
                            </div>
                        </div>

                    </>}

                    {selectedTab === 2 && <div style={{ display: "flex", justifyContent: "center", width: "100%", height: "100vh", background: "white", zIndex: "999999999" }}>
                        <img alt="loader" src={require(`../../assets/Images/loader.gif`)} style={{ margin: "auto", height: "5rem" }} />
                    </div>}

                </div>
            </div>
            <AnimatePresence>
                {showSuccessMessage && (
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        style={{
                            position: "fixed",
                            top: "5%",
                            left: "40%",
                            transform: "translateX(-50%)",
                            background: "#4CAF50",
                            color: "#fff",
                            padding: "10px 20px",
                            borderRadius: "5px",
                            fontSize: "16px",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                            zIndex: 1000,
                        }}
                    >
                        {message}
                    </motion.div>
                )}
                {showErrorMessage && (
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        style={{
                            position: "fixed",
                            top: "5%",
                            left: "40%",
                            transform: "translateX(-50%)",
                            background: "#DC143C",
                            color: "#fff",
                            padding: "10px 20px",
                            borderRadius: "5px",
                            fontSize: "16px",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                            zIndex: 1000,
                        }}
                    >
                        {error_message}
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );

}

export default AiPage;